module.exports = __webpack_public_path__ + "static/media/icon_drop_down.91a32e8f.svg";